<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <h1 class="title mb-0">{{ pageTitle }}</h1>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="filteredTestRequests.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <div class="col-lg-10">
          <app-page-header-selections class="mb-0"
            [headerSelections]="['All', 'Lab Test', 'Scan']"
            title="All Test Requests" (pageChanged)="changePageId($event)">
            <button class="btn btn-neutral" (click)="exportExcel('Test Requests')">
              <span class="btn-inner--icon">
                <i class="ni ni-cloud-download-95"> </i>
              </span>
              <span class="btn-inner--text"> Download as Excel </span>
            </button>
          </app-page-header-selections>
        </div>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <ngx-datatable id="tableMy" class="material ngx-datatable-custom" [rows]="filteredTestRequests"
        [columns]="columns" [limit]="pageSize" [offset]="currentPage-1"
        columnMode="force" externalPaging="true" [count]="totalItems" [scrollbarH]="true"
        [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
        [messages]="messages">
        <ng-template let-row="row" #testListRef ngx-datatable-row-detail-template>
          <ul *ngIf="row.tests?.length" class="m-0 pl-3">
            <li *ngFor="let test of row.tests">
              {{ test.name }}
            </li>
          </ul>
        </ng-template>
        <ng-template let-row="row" #uploadRef ngx-datatable-row-detail-template>
          <a
            class="btn btn-icon btn-secondary"
            type="button"
            (click)="onUploadTestResult(row)"
          >
            <span class="text-success btn-inner--icon">
              <i class="ni ni-cloud-download-95"> </i>
            </span>
            <span class="btn-inner--text"> Upload </span>
          </a>
        </ng-template>
        <ng-template let-row="row" #downloadRef ngx-datatable-row-detail-template>
          <span *ngIf="row.files?.length">
            <button
              class="btn btn-icon btn-secondary"
              type="button"
              (click)="downloadTestRequestResults(row)"
            >
              <span class="btn-inner--icon">
                <i class="ni ni-cloud-download-95"> </i>
              </span>
              <span class="btn-inner--text"> Download </span>
            </button>
          </span>
        </ng-template>
      </ngx-datatable>
    </div>
  </div>
</div>
